import React from 'react';
import PropTypes from 'prop-types';
import { TextField, useTheme } from '@mui/material';

const BaseInput = ({ label, value, onChange, error = false, helperText = '', ...props }) => {
  const theme = useTheme();
  return (
    <TextField
      variant="outlined"
      label={label}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      fullWidth
      sx={{
        "& input:-webkit-autofill": {
          backgroundColor: `${theme.palette.background.default} !important`,
          boxShadow: `0 0 0px 1000px ${theme.palette.background.default} inset`,
          WebkitTextFillColor: theme.palette.text.primary, // Adjust text color dynamically
        },
      }}
      {...props}
    />
  );
};

BaseInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

export default BaseInput;
